//
//
//
//
//
//
//
//
//
//
//

import pagedown from 'pagedown';
export default {
  name: 'Benefits',
  props: {
    benefits: {
      type: String,
      default: ''
    },
    image: {
      type: Object,
      default: () => ({
        url: '',
        alt: ''
      })
    },
    youTubeVideoId: {
      type: String,
      default: ''
    }
  },
  methods: {
    convertMarkdown(paragraph) {
      if (paragraph) {
        const safeConverter = pagedown.getSanitizingConverter();
        let html = safeConverter.makeHtml(paragraph);
        html = html.replace(/<p><strong>/g, '<h3>');
        html = html.replace(/<\/strong><\/p>/g, '</h3>');
        return html;
      }
      return '';
    }
  }
};
